/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, ButtonGroup, Icon } from 'semantic-ui-react'
import { intlFormat } from '../../../../../helpers/money'
import React, { useState } from 'react'
import useUser from '../../../../Shared/UserProvider/useUser'
import { CardContent } from '../../../Shared/Card'

const TopProductsCardContent = ({data}) => {
    const {user} = useUser()
    const [showByRevenue, setShowByRevenue] = useState(true)

    const displayData = showByRevenue ? data?.topCA : data?.top

    return (
      <CardContent
        css={css`
            padding: 1rem;
            display: flex;
            flex-direction: column;
        `}
      >
          <div
            css={css`
                display: flex;
                justify-content: center;
                margin-bottom: 1rem;
                flex-shrink: 0;
            `}
          >
              <ButtonGroup size="mini">
                  <Button
                    color={showByRevenue ? 'teal' : undefined}
                    active={showByRevenue}
                    onClick={() => setShowByRevenue(true)}
                    css={css`
                        &.ui.button {
                            font-size: 0.75rem;
                            padding: 0.5rem 0.75rem;
                        }
                    `}
                  >
                      <Icon name="euro sign"/> CA
                  </Button>
                  <Button
                    color={!showByRevenue ? 'teal' : undefined}
                    active={!showByRevenue}
                    onClick={() => setShowByRevenue(false)}
                    css={css`
                        &.ui.button {
                            font-size: 0.75rem;
                            padding: 0.5rem 0.75rem;
                        }
                    `}
                  >
                      <Icon name="box"/> Volume
                  </Button>
              </ButtonGroup>
          </div>
          <div
            css={css`
                flex: 1;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                min-height: 0;
            `}
          >
              {(displayData.map((product) => (
                  <div
                    key={product.identifier}
                    css={css`
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        padding: 0.4rem 0.6rem;
                        background: #f8f9fa;
                        color: #333;
                        border-radius: 4px;
                        font-size: 0.85rem;
                        border: 1px solid rgba(34, 36, 38, 0.1);
                    `}
                  >
                                <span
                                  css={css`
                                      flex: 1;
                                      font-weight: 500;
                                      overflow: hidden;
                                      text-overflow: ellipsis;
                                      white-space: nowrap;
                                  `}
                                >
                                    {product.name}
                                </span>
                      <span
                        css={css`
                            font-weight: bold;
                            font-size: 0.9rem;
                        `}
                      >
                                    {showByRevenue ?
                                      intlFormat(+product.sum, user.getCompanyCurrency(), user.getCompanyLocale()) :
                                      product.sum
                                    }
                                </span>
                  </div>
                ))
              )}
          </div>
      </CardContent>
    )
}

export { TopProductsCardContent }
